import { GTP_BET_BUILDER_COMBINATION_TYPE } from '~Betslip/uiModes/shared/GTPBetBuilder/constants';

/**
 * Generic Subscription Store middleware
 * Works for any subscribe/unsubscribe call that contains an array payload or arrays of
 * selectionIds in one property of the wsMessage. E.g.:
 * {
 *      'action': 'register',
 *      'type': 'gtp_betbuilder',
 *      'combinations': [
 *          [100, 200, 333],
 *          [56, 57]
 *      ]
 * }
 * Each array of selection ids represents one combination selection
 * Add to the switch statement to support other types
 * @param {Object} wsPayload websocket message to be sent (see example above)
 * @param {Object} param1 extra parameters that get passed to the function
 * @returns {Object} an updated payload
 *
 * NOTE: When you write your middleware you should check that it is only operating on intended
 * messages. If the message type is not the intended one then return it as is. E.g.:
 *
 *  myBasicMiddleware => (message, { subscriptionStore }) => {
 *      if (message.type !== 'my-type') {
 *          return message;
 *      }
 *
 *      // your logic
 *
 *      return updatedMessage; // OR false to prevent message from being sent at all
 * }
 */
export const sldGenericSubscriptionStoreMiddleware = (wsPayload, { subscriptionStore }) => {
    const { type, action } = wsPayload;
    if (!type || !action) {

        return wsPayload;
    }

    let selectionIdGroups = [];
    let payloadKey = '';

    switch (type) {
        case GTP_BET_BUILDER_COMBINATION_TYPE:
            payloadKey = 'combinations';
            selectionIdGroups = wsPayload[payloadKey];

            break;
        default:

            throw new Error(`wsMessage type "${type}" is not recognised...`);
    }

    let newSelectionIdGroups = [];
    switch (action) {
        case 'register':
            newSelectionIdGroups = subscriptionStore.subscribe({ type, selectionIdGroups });

            break;
        case 'unregister':
            newSelectionIdGroups = subscriptionStore.unsubscribe({ type, selectionIdGroups });

            break;
        default:
            break;
    }

    return {
        ...wsPayload,
        [payloadKey]: newSelectionIdGroups,
    };
};
